// extracted by mini-css-extract-plugin
export default {"expertTopBarContent":"withPedagogy_expertTopBarContent__RK3Me"};